export class ObjectTemplateParams {
  objet: string;
  serviceId: number;
}

export class ObjectTemplateDTO {
  id: number;
  objet: string;
  serviceId: number;
}
